import {
  getCategories,
  inventoryDetailsParentsByInventoryTypeId,
} from '../../utils/apiUtils/inventoryUtils';

const useDropdowns = () => {
  // Fetch function for categories
  const fetchCategories = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getCategories({
      pageNumber: pageParam,
      pageSize,
      searchString: searchTerm,
    });
    return response;
  };

  // Fetch function for subcategories
  const fetchSubCategories = async (categoryId) => {
    if (!categoryId) return [];
    const response = await inventoryDetailsParentsByInventoryTypeId(categoryId);
    return response;
  };

  // Transform category data to dropdown option format
  const transformCategoryOption = (category) => ({
    value: category.inventoryTypeId,
    label: category.inventoryType,
  });

  // Transform subcategory data to dropdown option format
  const transformSubCategoryOption = (subCategory) => ({
    value: subCategory.inventoryDetailsParentId,
    label: subCategory.inventoryParentName,
  });

  // Transform material data to dropdown option format
  const transformMaterialOption = (material, showAutoPo = false) => {
    const subCategoryData = material.inventoryDetailsParent;

    const subCategory = subCategoryData?.inventoryDetailsParentId
      ? {
          value: subCategoryData.inventoryDetailsParentId,
          label: subCategoryData.inventoryParentName,
        }
      : null;

    const category = subCategoryData?.inventoryType?.inventoryTypeId
      ? {
          value: subCategoryData.inventoryType.inventoryTypeId,
          label: subCategoryData.inventoryType.inventoryType,
        }
      : null;

    // Append only when both flags are true
    const label =
      material.inventoryName +
      (showAutoPo && material.raiseAutoPo === true ? '*' : '');

    return {
      value: material.inventoryDetailsId,
      label: label,
      measurementUnit: material.measurementUnit,
      subCategory: subCategory,
      category: category,
      cgst: material.cgst,
      sgst: material.sgst,
      hsnCode: material.hsnCode,
    };
  };

  // Error handler for fetch failures
  const handleFetchError = (errorMessage) => {
    window.triggerAlert({
      title: 'Error',
      type: 'error',
      message: errorMessage,
    });
  };

  return {
    fetchCategories,
    fetchSubCategories,
    handleFetchError,
    transformCategoryOption,
    transformSubCategoryOption,
    transformMaterialOption,
  };
};

export default useDropdowns;
